// @flow

import type { PersonalDetailsState } from "./types";

export const initialState: PersonalDetailsState = {
  requestsInProgress: 0,
  personalDetails: null,
  actionSummary: null,
  bespokeRecipient: null,
  changelog: {
    list: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
  },
  employeeAlertExclusions: null,
  modals: {
    addEmployee: {
      visible: false,
      employee: null,
    },
    personalDetails: {
      visible: false,
      modalType: "",
    },
    addAlertExclusion: {
      visible: false,
      step: 1,
    },
    editAlertExclusion: {
      visible: false,
    },
    removeAlertExclusion: {
      visible: false,
      alertName: null,
    },
    employeeAlertExclusionId: null,
    exclusionReasonDetails: null,
    alert: null,
  },
  schema: null,
  accessLeveSchema: null,
  accessLevel: null,
  employeeAlertExclusionSchema: null,
};
